<div class="attachment-item" [ngClass]="{ 'is-editing': isEditing }">
  <div class="thumbnail">
    <img [src]="attachmentView.fileUrl" (click)="onViewAttachment()" />
  </div>

  <ng-container [ngSwitch]="isEditing">
    <div *ngSwitchCase="true" class="editing-form-wrapper">
      <app-attachment-info-form
        [attachment]="attachmentView.attachment"
        [trackingScreenName]="trackingScreenName"
        [trackingObject]="trackingObject"
        (onUpdateAttachmentInfo)="onUpdateAttachment($event)"
        (onCancel)="toggleForm(false)"
      >
      </app-attachment-info-form>
    </div>

    <div
      *ngSwitchDefault
      class="content-wrapper"
      (click)="toggleForm(true)"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="attachmentTapped"
    >
      <div class="title-description-wrapper">
        <span class="title">
          {{ attachmentView.title }}
        </span>

        <div class="description-wrapper">
          <p [ngClass]="{ 'has-error': attachmentView.error }">
            {{
              attachmentView.error
                ? attachmentView.error
                : attachmentView.description
            }}
          </p>

          <span
            *ngIf="!attachmentView.description && !attachmentView.error"
            class="description-placeholder"
          >
            {{ 'ACTION.ADD_DESCRIPTION' | translate }}...
          </span>
        </div>
      </div>

      <button
        type="button"
        class="delete-action"
        (click)="onDelete()"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="attachmentDeleted"
      >
        {{ 'ACTION.DELETE' | translate }}
      </button>
    </div>
  </ng-container>
</div>

<app-attachment-view-dialog
  [dialogId]="dialogId"
  [attachment]="attachmentView"
  [trackingDialogName]="attachmentDialogName"
  [trackingScreenName]="trackingScreenName"
>
</app-attachment-view-dialog>
